module.exports = __webpack_public_path__ + "assets/img/ae10-kw.svg";